common.View.create('canvas.blocks.custom.iconSlider.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let element = this.element.find('.swiper').get(0);
        
        new Swiper(element, {
            slidesPerView: 1,
            // navigation: {
            //     nextEl: this.element.find('.swiper-button-next').get(0),
            //     prevEl: this.element.find('.swiper-button-prev').get(0),
            // },
            pagination: {
                el: this.element.find(".swiper-pagination").get(0),
                clickable: true, // Enables clickable dots
            },
            spaceBetween: 32,
            breakpoints: {
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 4,
                }
            }
        });
    }
});